<template>
    <RouterLink class="nav-link" :to="to" v-if="to.name !== null">
        <slot></slot>
    </RouterLink>
    <div class="nav-link" v-else>
        <slot></slot>
    </div>
</template>
<script>
export default {
    name: "AppNavItemLink",
    props: {
        to: {
            type: Object,
            required: true
        }
    }
}
</script>